import { render, staticRenderFns } from "./PatientNextOfKinForm.vue?vue&type=template&id=2b7c75ec&"
import script from "./PatientNextOfKinForm.vue?vue&type=script&lang=js&"
export * from "./PatientNextOfKinForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports